import script from "./ErrorsViewer.vue?vue&type=script&lang=js"
export * from "./ErrorsViewer.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__